import { ProfileContainer } from "../Containers/ProfileContainer"

export const ProfileViewer = () => (
    <ProfileContainer/>
) 
